import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Practice, AuthState } from '../../types';


const initialState: AuthState = {
  token: null,
  refreshToken: null,
  practice: null,
  loading: false,
  error: null,
  leadId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    startInit(state) {
      state.loading = true;
      state.error = null;
    },
    initSuccess(
      state,
      action: PayloadAction<{ token: string; refreshToken: string; practice: Practice }>
    ) {
      state.loading = false;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.practice = action.payload.practice;
    },
    initFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.token = null;
      state.refreshToken = null;
      state.practice = null;
    },
    updateToken(state, action: PayloadAction<{ token: string; refreshToken?: string }>) {
      state.token = action.payload.token;
      if (action.payload.refreshToken) {
        state.refreshToken = action.payload.refreshToken;
      }
    },
    clearAuth(state) {
      state.token = null;
      state.refreshToken = null;
      state.practice = null;
      state.error = null;
      state.loading = false;
      state.leadId = null;
    },
    setLeadId(state, action: PayloadAction<string>) {
      state.leadId = action.payload;
    },
  },
});

export const { startInit, initSuccess, initFailure, updateToken, clearAuth, setLeadId } = authSlice.actions;
export default authSlice.reducer;





